<div id="app">
  <header class="App-header"></header>
  <main>
    <section class="">
      <div class="message"><i class="i-file-invoice big-display"></i>
        <div class="h3">Get a link to view and sign estimates here.</div>
      </div>
    </section>
  </main>
  <footer>
    <div style="margin: 5rem;"><small style="color: white;">by</small> <img src="/assets/projul-logo-white.svg"
        alt="Projul Logo"></div>
  </footer>
</div>
